export class LocationModel {
  description: string;



  constructor(description?: string) {
    this.description = description;
  }
}
